import { Card, Box, Typography, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip } from "@mui/material";
import { IItemNotaFiscal } from "../../../../../types/api/fiscal/detalhe-nfe-entrada";

export default function ItensNotaFiscal({ itens }: { itens: IItemNotaFiscal[] }) {
  return (
    <Card variant="outlined">
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          Itens da Nota Fiscal ({itens.length})
        </Typography>
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>
                <Typography variant="subtitle2" fontWeight="bold">Código</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="subtitle2" fontWeight="bold">Descrição</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="subtitle2" fontWeight="bold">Qtd</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="subtitle2" fontWeight="bold">Produto relacionado</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              itens.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="body2">
                      Nenhum item encontrado para esta nota fiscal.
                    </Typography>
                  </TableCell>
                </TableRow>
              )
            }
            {
              itens.length > 0
              && itens.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    <Typography variant="body2">{item.produto?.id ?? '-'}</Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2" fontWeight="medium">
                      {item.descricao_produto}

                    </Typography>
                    {item.ncm && (
                      <Chip
                        size="small"
                        label={`NCM ${item.ncm}`}
                        variant="outlined"
                        sx={{ fontSize: "0.7rem", mt: 0.5 }}
                      />
                    )}
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      {Number(item.quantidade_comercial).toLocaleString("pt-BR")}{" "}
                      {item.unidade_comercial}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      {item.produto ? item.produto.nome : "Não possui produto relacionado"}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
